import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import DefaultView from "../views/DefaultView.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: DefaultView,
  },
  {
    path: "/json",
    name: "json",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "json" */ "../views/JsonView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
